import {NgModule} from '@angular/core';
import {DoubleCheckPopupComponent} from './components/double-check-popup/double-check-popup.component';
import {SideNavComponent} from './components/side-nav/side-nav.component';
import {RadioButtonModule} from 'primeng/radiobutton';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {TooltipModule} from 'primeng/tooltip';
import {CustomAutoFocusDirective} from './directives/custom-auto-focus.directive';
import {CurrentUserMenuViewComponent} from './components/current-user-menu-view/current-user-menu-view.component';
import {TabViewComponent} from './components/tab-view/tab-view.component';
import {KeyFilterModule} from 'primeng/keyfilter';
import {HtmlEditorComponent} from './components/html-editor/html-editor.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import {TitleBarComponent} from './components/title-bar/title-bar.component';
import {PleaseWaitComponent} from './components/please-wait/please-wait.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {UpdaterComponent} from './components/updater/updater.component';
import {DialogModule} from 'primeng/dialog';
import {RippleModule} from 'primeng/ripple';
import {HtmlViewerComponent} from './components/html-viewer/html-viewer.component';
import {SideDialComponent} from './components/side-dial/side-dial.component';
import {SpeedDialModule} from 'primeng/speeddial';
import {ActivityLogModule} from '../activity-log/activity-log.module';
import {ProblemDetailsDirective} from './directives/problem-details.directive';
import {ChatModule} from '../chat/chat.module';
import {AvatarModule} from 'primeng/avatar';
import {GodhLoaderComponent} from './components/godh-loader/godh-loader.component';
import {AccountSettingsModule} from '../account-settings/account-settings.module';
import {NotificationBadgeComponent} from './components/notification-badge/notification-badge.component';
import {BadgeModule} from 'primeng/badge';
import {NotificationListComponent} from './components/notification-list/notification-list.component';
import {NotificationListEntryComponent} from './components/notification-list-entry/notification-list-entry.component';
import {AvatarComponentComponent} from './components/avatar-component/avatar-component.component';
import {ClickOutsideDirective} from './directives/click-outside-scope.directive';
import {HoverClassDirective} from './directives/hover-class.directive';
import {PasswordFieldComponent} from './components/password-field/password-field.component';
import {ValidationEntryComponent} from './components/validation-entry/validation-entry.component';
import {ValidationDirective} from './directives/validation.directive';
import {LazyLoadedComponentComponent} from './components/lazy-loaded-component/lazy-loaded-component.component';
import {SkeletonModule} from 'primeng/skeleton';
import {MomentDateComponent} from '../moment-date/moment-date.component';
import {MomentLabelComponent} from '../_widget-library/moment-label/moment-label.component';
import {SnippetPopupComponent} from "../snippet/components/snippet-popup/snippet-popup.component";
import {DisableDoubleClickDirective} from "./directives/disable-double-click.directive";
import {FeedbackModule} from "../feedback/feedback.module";

@NgModule({
    declarations: [
        DoubleCheckPopupComponent,
        SideNavComponent,
        CustomAutoFocusDirective,
        ProblemDetailsDirective,
        ClickOutsideDirective,
        HoverClassDirective,
        CurrentUserMenuViewComponent,
        TabViewComponent,
        HtmlEditorComponent,
        HtmlViewerComponent,
        TitleBarComponent,
        PleaseWaitComponent,
        UpdaterComponent,
        SideDialComponent,
        GodhLoaderComponent,
        NotificationBadgeComponent,
        NotificationListComponent,
        NotificationListEntryComponent,
        AvatarComponentComponent,
        PasswordFieldComponent,
        ValidationEntryComponent,
        ValidationDirective,
        LazyLoadedComponentComponent,
        MomentDateComponent,
        MomentLabelComponent,
        SnippetPopupComponent,
        DisableDoubleClickDirective,
    ],
  imports: [
    RadioButtonModule,
    FormsModule,
    CommonModule,
    DropdownModule,
    TooltipModule,
    KeyFilterModule,
    SelectButtonModule,
    ProgressSpinnerModule,
    DialogModule,
    RippleModule,
    SpeedDialModule,
    ActivityLogModule,
    ChatModule,
    AvatarModule,
    AccountSettingsModule,
    BadgeModule,
    SkeletonModule,
    FeedbackModule,
  ],
  providers: [],
    exports: [
        DoubleCheckPopupComponent,
        SideNavComponent,
        CustomAutoFocusDirective,
        ClickOutsideDirective,
        HoverClassDirective,
        TabViewComponent,
        HtmlEditorComponent,
        TitleBarComponent,
        PleaseWaitComponent,
        UpdaterComponent,
        HtmlViewerComponent,
        SideDialComponent,
        ProblemDetailsDirective,
        GodhLoaderComponent,
        PasswordFieldComponent,
        ValidationEntryComponent,
        ValidationDirective,
        GodhLoaderComponent,
        LazyLoadedComponentComponent,
        MomentDateComponent,
        MomentLabelComponent,
        SnippetPopupComponent,
      DisableDoubleClickDirective,
    ]
})
export class AppCommonModule {
}
